import { FragmentOf, gql } from '@/utilities/gql';

export const NARRATIVE_URL_COMPANY_FRAGMENT = gql(`
  fragment NarrativeUrlCompanyFields on Company @_unmask {
    country {
      iso2
    }
    primaryIndustry {
      slug
    }
    uniqueSymbolSlug
    nameSlug
  }
`);

export const getNarrativeUrlSegments = ({
  country,
  primaryIndustry,
  uniqueSymbolSlug,
  nameSlug,
}: FragmentOf<typeof NARRATIVE_URL_COMPANY_FRAGMENT>) => {
  return {
    country: String(country?.iso2 || '').toLowerCase(),
    primaryIndustry: String(primaryIndustry?.slug || '').toLowerCase(),
    uniqueSymbolSlug: String(uniqueSymbolSlug || '').toLowerCase(),
    nameSlug: String(nameSlug || '').toLowerCase(),
  };
};

type Props = {
  segments: FragmentOf<typeof NARRATIVE_URL_COMPANY_FRAGMENT>;
  slug?: string;
};

export const getNarrativeUrl = ({ segments, slug }: Props) => {
  const { country, primaryIndustry, uniqueSymbolSlug, nameSlug } =
    getNarrativeUrlSegments(segments);

  const BASE_URL = '/community/narratives';

  if (!country || !primaryIndustry || !uniqueSymbolSlug) {
    return `${BASE_URL}`;
  }

  if (!slug) {
    return `${BASE_URL}/${country}/${primaryIndustry}/${uniqueSymbolSlug}/${nameSlug}`;
  }

  return `${BASE_URL}/${country}/${primaryIndustry}/${uniqueSymbolSlug}/${nameSlug}/${slug}`;
};
